import React, {useState} from 'react'
import {ButtonsBox, StyledButton} from './styles'
import ShuffleDeck from '../../../../images/icons/shuffle-icon.svg'
import ShuffleDeckHover from '../../../../images/icons/shuffle-icon-white.svg'
import RandomizeDeck from '../../../../images/icons/randomize-icon.svg'
import RandomizeDeckHover from '../../../../images/icons/randomize-icon-white.svg'
import FlipDeck from '../../../../images/icons/flip-deck-icon.svg'
import FlipDeckHover from '../../../../images/icons/flip-deck-icon-white.svg'
import ResetMastered from '../../../../images/icons/reset-mastered-icon.svg'
import ResetMasteredHover from '../../../../images/icons/reset-mastered-icon-white.svg'
import CreateFlashCard from '../../../../images/icons/custom-card-icon.svg'
import CreateFlashCardHover from '../../../../images/icons/custom-card-icon-white.svg'

type Props = {
  setFlashCardFormToggle: (value: boolean) => void
  areCardsFlipped: boolean
  setFlashCardNumber: (value: number) => void
  updateMenuAction: (value: string) => void
}

const View = ({
  setFlashCardFormToggle,
  areCardsFlipped,
  setFlashCardNumber,
  updateMenuAction,
}: Props) => {
  const [hoverStates, setHoverStates] = useState<boolean[]>([
    false,
    false,
    false,
    false,
    false,
  ])

  const handleMouseEnter = (index: number) => {
    setHoverStates(
      prev => prev?.map((hover, i) => (i === index ? true : hover)),
    )
  }

  const handleMouseLeave = (index: number) => {
    setHoverStates(
      prev => prev?.map((hover, i) => (i === index ? false : hover)),
    )
  }

  return (
    <ButtonsBox>
      <StyledButton
        onClick={() => {
          updateMenuAction('shuffle')
          setFlashCardNumber(1)
        }}
        onMouseEnter={() => handleMouseEnter(0)}
        onMouseLeave={() => handleMouseLeave(0)}
      >
        <img
          src={hoverStates[0] ? ShuffleDeckHover : ShuffleDeck}
          alt="Shuffle Deck"
        />
        Shuffle Deck
      </StyledButton>

      <StyledButton
        onClick={() => {
          updateMenuAction('randomize')
        }}
        onMouseEnter={() => handleMouseEnter(1)}
        onMouseLeave={() => handleMouseLeave(1)}
      >
        <img
          src={hoverStates[1] ? RandomizeDeckHover : RandomizeDeck}
          alt="Randomize Deck"
        />
        Randomize
      </StyledButton>

      <StyledButton
        onClick={() => updateMenuAction('flip')}
        onMouseEnter={() => handleMouseEnter(2)}
        onMouseLeave={() => handleMouseLeave(2)}
      >
        <img src={hoverStates[2] ? FlipDeckHover : FlipDeck} alt="Flip Deck" />
        Flip Deck To {areCardsFlipped ? 'Front' : 'Back '}
      </StyledButton>

      <StyledButton
        onClick={() => updateMenuAction('reset')}
        onMouseEnter={() => handleMouseEnter(3)}
        onMouseLeave={() => handleMouseLeave(3)}
      >
        <img
          src={hoverStates[3] ? ResetMasteredHover : ResetMastered}
          alt="Reset All Mastered"
        />
        Reset All Mastered
      </StyledButton>

      <StyledButton
        onClick={() => setFlashCardFormToggle(true)}
        onMouseEnter={() => handleMouseEnter(4)}
        onMouseLeave={() => handleMouseLeave(4)}
      >
        <img
          src={hoverStates[4] ? CreateFlashCardHover : CreateFlashCard}
          alt="Create Custom Card"
        />
        Create Custom Card
      </StyledButton>
    </ButtonsBox>
  )
}

export default View
